const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['mobile-not-ready'] = require('../middleware/mobile-not-ready.js')
middleware['mobile-not-ready'] = middleware['mobile-not-ready'].default || middleware['mobile-not-ready']

middleware['notAuthenticated'] = require('../middleware/notAuthenticated.js')
middleware['notAuthenticated'] = middleware['notAuthenticated'].default || middleware['notAuthenticated']

export default middleware
